<div class="example-container-backendsetup">
  <h2>Notification</h2>

  <form [formGroup]="ENForm" autocomplete="off">
    <div formArrayName="ENRows">
      <table mat-table [dataSource]="emailNotifications" class="mat-elevation-z8 mat-table-custom">

        <ng-container matColumnDef="headeraddbutton">
          <th mat-header-cell *matHeaderCellDef class="butt-col">
            <div>
              @if (!isSettingRow) {
                <button mat-button
                  (click)="addNewRow()"
                  matTooltip="Add new email notification"
                  >
                  <mat-icon>add_box</mat-icon>
                </button>
              }
            </div>
          </th>
          <td mat-cell *matCellDef="let row"></td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef class="col-name">Name</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row" class="col-name">
            @if (row.get('isEditable')?.value) {
              {{ row.get('name')?.value }}
            } @else {
              <mat-form-field appearance="fill" floatLabel="auto" style="width: 100%">
                <input matInput formControlName="name" placeholder="Name" required/>
              </mat-form-field>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef class="col-email">Email</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row" class="col-email">
            @if (row.get('isEditable')?.value) {
              {{ row.get('email')?.value }}
            } @else {
              <mat-form-field appearance="fill" floatLabel="auto" style="width: 100%">
                <input matInput formControlName="email" type="email" placeholder="Email" required/>
              </mat-form-field>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="isactive">
          <th mat-header-cell *matHeaderCellDef class="col-active">Active</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row" class="col-active">
            @if (row.get('isEditable')?.value) {
              <mat-checkbox [checked]="row.get('isActive')?.value" disabled></mat-checkbox>
            } @else {
              <mat-checkbox formControlName="isActive"></mat-checkbox>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="edit">
          <th mat-header-cell *matHeaderCellDef class="col-edit">Actions</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row" class="col-edit">
            <div class="row-actions">
              @if (row.get('isEditable')?.value) {
                <button mat-icon-button type="button" (click)="editRow(i)" matTooltip="Edit">
                  <mat-icon>edit</mat-icon>
                </button>
              } @else {
                <button mat-icon-button type="button"
                  (click)="createOrUpdateEmail(i)"
                  matTooltip="Save"
                  color="primary">
                  <mat-icon>save</mat-icon>
                </button>
                <button mat-icon-button type="button"
                  (click)="cancelEdit(i)"
                  matTooltip="Cancel">
                  <mat-icon>close</mat-icon>
                </button>
              }
            </div>
          </td>
        </ng-container>

        @if (!isSettingRow) {
          <ng-container matColumnDef="delete">
            <th mat-header-cell *matHeaderCellDef class="col-delete">Delete</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row" class="col-delete">
              @if (!isSettingRow) {
                <button mat-icon-button type="button"
                  (click)="deleteEmailNotification(row.value)"
                  matTooltip="Delete"
                  color="warn"
                  [disabled]="!row.get('isEditable')?.value"
                  >
                  <mat-icon>delete</mat-icon>
                </button>
              }
            </td>
          </ng-container>
        }

        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
        <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"></tr>

      </table>
    </div>
  </form>
</div>
